(function ($) {
    class W4D_ProductQuantity {
        constructor() {
            this.initSelectors()
            this.bindEvents();
        }

        initSelectors() {

        }

        bindEvents() {
            $(document).on('keydown', '.product-quantity__number', (e) => this.handleArrowPressInQuantity(e));

            $(document).on('click', '.product-quantity', (e) => {
                const $container = $(e.currentTarget);
                const $input = $container.find('.product-quantity__number');
                $input.focus();

                if($(e.target).hasClass('icon-minus') || $(e.target).hasClass('icon-plus')) {
                    e.preventDefault();
                    e.stopPropagation();
                    const action = $(e.target).hasClass('icon-minus') ? 'decrease' : 'increase';
                    this.handleQuantityChange($container, action);
                }
            });

            $(document).on('focusout', '.product-quantity', (e) => this.handleQuantityFocusOut(e));
            $(document).on('input', '.product-quantity__number', (e) => this.handleDirectInputChange(e));
            $(document).on('click', '.product-table .product-quantity__cart', (e) => e.stopPropagation());
        }

        handleArrowPressInQuantity(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                let $input = $(e.target);
                let location = $input.data('location');
                if (location === 'quick-order') {
                    return;
                }
                let currentValue = parseFloat($input.val().replace(',', '.')) || 0;

                let step = parseFloat($input.attr('step') || 1);
                let decimalPlaces = (step.toString().includes('.')) ?
                    step.toString().split('.')[1].length : 0;

                let formattedValue = currentValue.toFixed(decimalPlaces);
                let cleanValue = parseFloat(formattedValue).toString();
                let displayValue = cleanValue.replace('.', ',');

                $input.val(displayValue)
                    .attr('value', cleanValue)
                    .trigger('change');

                document.activeElement.blur();
                return;
            }
            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.preventDefault();
                let $input = $(e.target);
                let min = parseFloat($input.attr('min') || 0);
                let maxValue = parseFloat($input.attr('max'));
                let step = parseFloat($input.attr('step') || 1);
                let currentVal = parseFloat($input.val().replace(',', '.')) || 0;
                let originalValue = parseFloat($input.data('quantity'));
                let newVal = e.key === 'ArrowUp' ? currentVal + step : currentVal - step;

                newVal = Math.max(min, newVal);
                newVal = Math.min(maxValue, newVal);

                // Format with appropriate decimal places based on step
                let decimalPlaces = (step.toString().includes('.')) ?
                    step.toString().split('.')[1].length : 0;

                // Format the number with decimal places
                let formattedValue = newVal.toFixed(decimalPlaces);

                // Remove trailing zeros and decimal point if needed
                let cleanValue = parseFloat(formattedValue).toString();
                let displayValue = cleanValue.replace('.', ',');

                $input.val(displayValue)
                    .attr('value', cleanValue)
                    .trigger('input');

                // Check if we're in product flyout and update button state
                const location = $input.data('location');
                if (location === 'product-flyout' || location === 'single-product' || location === 'variable-product') {
                    const $container = $input.parent();
                    const $sidebarContent = $container.closest('.product-flyout__content');
                    const updateCartButton = $sidebarContent.find('.w4d_update_cart_button');
                    const addToCartButton = $sidebarContent.find('.w4d_add_to_cart_button');
                    const actionButton = updateCartButton.length ? updateCartButton : addToCartButton;

                    const productId = actionButton.data('product-id');
                    const isVariableProduct = $(`.product-table__row[data-product-id="${productId}"]`).data('product-type') === 'variable';

                    if (actionButton.length) {
                        actionButton
                            .attr('data-quantity', newVal)
                            .data('quantity', newVal);

                        // Only disable button for simple products when value equals original value
                        if (!isVariableProduct) {
                            actionButton.prop('disabled', newVal === originalValue);
                        }
                    }
                    this.handleFlyoutQuantityUpdate($input[0]);
                }
            }

        }

        handleDirectInputChange(e) {
            let $input = $(e.target);
            let originalValue = parseFloat($input.data('quantity'));
            let validationResult = W4D_ProductQuantityHelper.validateProductQuantityDirectInput(e.target, e);
            let location = $input.data('location');
            $input.attr('value', validationResult.numericValue);

            if (location === 'table-view') {
                let $container = $input.parent();
                if (validationResult.numericValue !== originalValue) {
                    $container.addClass('product-quantity--changed');
                } else {
                    $container.removeClass('product-quantity--changed');
                }
            }

            if (location === 'quick-order') {
                const $row = $input.closest('.quick-order__row');
                const rowIndex = $row.index();
                W4D_QuickOrder.updateLocalStorageQuantity(rowIndex, validationResult.numericValue);
            }
        }

        handleQuantityChange(container, action) {
            let input = container.find('.product-quantity__number');
            let currentValue = parseFloat(input.val().replace(',', '.')) || 0;
            let originalValue = parseFloat(input.data('quantity'));
            let step = parseFloat(input.attr('step') || 1);
            let max = parseFloat(input.attr('max'));
            let min = parseFloat(input.attr('min') || 0);
            let location = input.data('location');

            if (action === 'increase' && currentValue < max) {
                currentValue += step;
            } else if (action === 'decrease' && currentValue > min) {
                currentValue = Math.max(min, currentValue - step);
            }

            // Round to the same precision as the step value
            const decimalPlaces = step.toString().includes('.')
                ? step.toString().split('.')[1].length
                : 0;
            currentValue = parseFloat(currentValue.toFixed(decimalPlaces));

            if (location === 'table-view') {
                if (currentValue === originalValue) {
                    container.removeClass('product-quantity--changed');
                } else {
                    container.addClass('product-quantity--changed');
                }
            }

            if (location === 'quick-order') {
                const $row = input.closest('.quick-order__row');
                const rowIndex = $row.index();
                W4D_QuickOrder.updateLocalStorageQuantity(rowIndex, currentValue);
            }

            let displayValue = currentValue.toString().replace('.', ',');
            input.val(displayValue).attr('value', currentValue).trigger('change');

            if (location === 'product-flyout' || location === 'single-product' || location === 'variable-product') {
                const $sidebarContent = container.closest('.product-flyout__content');
                const updateCartButton = $sidebarContent.find('.w4d_update_cart_button');
                const addToCartButton = $sidebarContent.find('.w4d_add_to_cart_button');
                const actionButton = updateCartButton.length ? updateCartButton : addToCartButton;

                const productId = actionButton.data('product-id');
                const isVariableProduct = $(`.product-table__row[data-product-id="${productId}"]`).data('product-type') === 'variable';

                if (actionButton.length) {
                    actionButton
                        .attr('data-quantity', currentValue)
                        .data('quantity', currentValue);

                    // Only disable button for simple products when value equals original value
                    if (!isVariableProduct) {
                        actionButton.prop('disabled', currentValue === originalValue);
                    }
                }
                this.handleFlyoutQuantityUpdate(input);
            }
        }

        handleQuantityFocusOut(e) {
            const $container = $(e.currentTarget);
            const $input = $container.find('.product-quantity__number');
            const location = $input.data('location');

            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
            }

            // Check immediately if this is a cart update and value has changed
            if (location === 'cart') {
                let inputValue = $input.val();
                if (inputValue.endsWith('.') || inputValue.endsWith(',')) {
                    inputValue = inputValue.slice(0, -1);
                }

                let originalValue = parseFloat($input.data('quantity'));
                let currentValue = parseFloat(inputValue.replace(',', '.'));

                // Set loading state immediately if value changed
                if (currentValue !== originalValue) {
                    $('.cart').addClass('cart--loading');
                    $('.cart-collaterals').addClass('cart-collaterals--loading');
                }
            }

            // Set a timeout to check if the container is still being interacted with
            this.updateTimeout = setTimeout(() => {
                if (!$container.has(document.activeElement).length) {
                    const location = $input.data('location');

                    // Formatirajte vrijednost ako završava s decimalnim separatorom
                    let inputValue = $input.val();
                    if (inputValue.endsWith('.') || inputValue.endsWith(',')) {
                        inputValue = inputValue.slice(0, -1); // Uklonite decimalni separator
                        $input.val(inputValue);
                    }

                    let originalValue = parseFloat($input.data('quantity'));
                    let currentValue = parseFloat(inputValue.replace(',', '.'));

                    // Early return if the value hasn't changed
                    if (currentValue === originalValue) {
                        $input.prop('disabled', false);
                        // Remove loading state if no changes for cart
                        if (location === 'cart') {
                            $('.cart').removeClass('cart--loading');
                            $('.cart-collaterals').removeClass('cart-collaterals--loading');
                        }
                        return;
                    }

                    if (location === 'cart') {
                        if (currentValue === 0) {
                            W4D_Cart.handleRemoveCartItem($input)
                        } else {
                            W4D_Cart.handleUpdateCartOnCartPage($input);
                        }
                    }

                    if (location === 'product-flyout' || location === 'variable-product' || location === 'single-product') {
                        this.handleFlyoutQuantityUpdate($input[0]);
                    }

                    if (location === 'table-view' || location === 'quick-order' || location === 'single-product') {
                        this.handleSingleQuantityUpdate($input[0], location);
                    }

                    $input.prop('disabled', false);
                }
            }, 150);
        }

        handleSingleQuantityUpdate(input, location) {
            const $input = $(input);
            const inputValue = parseFloat($input.attr('value'));

            if (location === 'table-view' || location === 'variable-product') {
                const $step = parseFloat($input.attr('step'));
                const $step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($step);
                const remainder = inputValue % $step;
                let roundedValue;

                if (remainder > 0) {
                    // Ako vrijednost nije višekratnik koraka, zaokruži na sljedeći višekratnik
                    roundedValue = W4D_ProductQuantityHelper.roundToDecimalPlaces(Math.ceil(inputValue / $step) * $step, $step_decimal_places);
                } else {
                    // Vrijednost je već višekratnik koraka, zadrži je kakva jest
                    roundedValue = inputValue;
                }

                const displayValue = String(roundedValue).replace('.', ',');

                $input.val(displayValue)
                    .attr('value', roundedValue)
                    .attr('data-quantity', roundedValue)
                    .data('quantity', roundedValue)
                    .trigger('change');

                if (location === 'table-view') {
                    W4D_Cart.handleUpdateCart($input);
                }
            }
        }

        handleFlyoutQuantityUpdate(input) {
            const $input = $(input);
            const oldQty = parseFloat($input.data('quantity'));
            const inputValue = parseFloat($input.attr('value'));
            const numericValue = parseFloat($input.val().replace(',', '.'));
            const $step = parseFloat($input.attr('step'));
            const $step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($step);
            const $faktor = parseFloat($input.data('faktor'));

            if ($faktor !== 1) {
                let $jm1_input, $jm2_input;
                let $jm1_val, $jm2_val;

                if ($input.hasClass('js-jm1')) {
                    $jm1_input = $input;
                    $jm2_input = $jm1_input.parent().parent().find('.js-jm2');
                    $jm1_val = numericValue;
                    $jm2_val = parseFloat($jm2_input.val());
                    let $jm2_step = parseFloat($jm2_input.attr('step'));
                    let $jm2_step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($jm2_step);

                    const remainder = $jm1_val % $step;
                    if (remainder > 0) {
                        $jm1_val = W4D_ProductQuantityHelper.roundToDecimalPlaces(Math.ceil($jm1_val / $step) * $step, $step_decimal_places);
                        $jm2_val = W4D_ProductQuantityHelper.roundToDecimalPlaces($jm1_val * $faktor, $jm2_step_decimal_places);
                    } else {
                        $jm2_val = W4D_ProductQuantityHelper.roundToDecimalPlaces($jm1_val * $faktor, $jm2_step_decimal_places);
                    }
                } else {
                    $jm2_input = $input;
                    $jm1_input = $jm2_input.parent().parent().find('.js-jm1');
                    $jm1_val = parseFloat($jm1_input.val());
                    $jm2_val = numericValue;
                    let $jm1_step = parseFloat($jm1_input.attr('step'));
                    let $jm1_step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($jm1_step);

                    const remainder = $jm2_val % $faktor;
                    if (remainder > 0) {
                        $jm1_val = W4D_ProductQuantityHelper.roundToDecimalPlaces(Math.ceil(($jm2_val / ($faktor * $jm1_step))) * $jm1_step, $jm1_step_decimal_places);
                        $jm2_val = W4D_ProductQuantityHelper.roundToDecimalPlaces($jm1_val * $faktor, $step_decimal_places);
                    } else {
                        $jm1_val = W4D_ProductQuantityHelper.roundToDecimalPlaces($jm2_val / $faktor, $step_decimal_places);
                    }
                }

                const $jm1_display = String($jm1_val).replace('.', ',');
                const $jm2_display = String($jm2_val).replace('.', ',');

                $jm1_input.val($jm1_display).attr('value', $jm1_val).trigger('change');
                $jm2_input.val($jm2_display).attr('value', $jm2_val).trigger('change');
            } else {
                const remainder = numericValue % $step;
                let roundedValue;

                if (remainder > 0) {
                    // Round up to the next step increment using the same logic as in the dual unit case
                    roundedValue = W4D_ProductQuantityHelper.roundToDecimalPlaces(Math.ceil(numericValue / $step) * $step, $step_decimal_places);
                } else {
                    // Value is already a multiple of step, keep it as is
                    roundedValue = numericValue;
                }

                const displayValue = String(roundedValue).replace('.', ',');

                $input.val(displayValue).attr('value', roundedValue).trigger('change');
            }

            const $container = $input.parent();
            let $sidebarContent = $container.closest('.product-flyout__content');

            // For variable products in shop sidebar
            if ($sidebarContent.length === 0) {
                $sidebarContent = $input.closest('.shop-sidebar');
            }

            const updateCartButton = $sidebarContent.find('.w4d_update_cart_button');
            const addToCartButton = $sidebarContent.find('.w4d_add_to_cart_button');
            const actionButton = updateCartButton.length ? updateCartButton : addToCartButton;

            const productId = actionButton.data('product-id');
            const isVariableProduct = $(`.product-table__row[data-product-id="${productId}"]`).data('product-type') === 'variable';

            if (actionButton.length) {
                const currentValue = parseFloat($input.attr('value'));

                actionButton
                    .attr('data-quantity', currentValue)
                    .data('quantity', currentValue);

                // Only disable button for simple products when value equals original value
                if (updateCartButton.length && !isVariableProduct) {
                    updateCartButton.prop('disabled', currentValue === oldQty);
                }
            }
        }
    }

    $(document).ready(function () {
        window.W4D_ProductQuantity = new W4D_ProductQuantity();
    });

})(jQuery);